// State-level holidays (e.g. Minas Gerais - MG)
export const stateFixedHolidays = [
  {
    name: "Data Magna do Estado de Minas Gerais",
    month: 4,
    day: 21,
    state: "MG",
    scope: "state",
    scheduleTarget: "domingo"
  }
];
